// extracted by mini-css-extract-plugin
module.exports = {"container":"VerifyBankAccount_container__Ls1lQ","screenHeaderContainer":"VerifyBankAccount_screenHeaderContainer__1QnUT","verifyButton":"VerifyBankAccount_verifyButton__1i3xQ"};